import { useActAsSupport } from 'Logic/ActAsSupport.js'
import getValidTerminationDates from 'Logic/getValidTerminationDates.js'
import View from './view.js'
import React from 'react'

export default function Logic() {
  let [isActingAsSupport] = useActAsSupport()
  return <View from={getValidTerminationDates(isActingAsSupport)} />
}
